@if (type() === 'full') {
  <div class="container">
    @if (!readOnly) {
      <app-file-input
        class="file-input"
        [files]="files"
        [maxFiles]="maxFiles()"
        [existingFileCount]="attachmentCount"
        type="full"
        (onFilesAttached)="onFileAttached($event)"></app-file-input>
    }
    <!-- 1st: Uses files as viewer source -->
    <app-file-preview [files]="selectedAndUploadedFiles" (thumbnailClicked)="onThumbnailClicked($event, 'default')"></app-file-preview>
  </div>
} @else {
  <mc-modal heading="Images" fit="small" dimension="large" [open]="openUploadDialog" (closed)="closeUploadDialog()">
    <p style="font-size: 12px">
      @if (inspectionDetailsWithLine()?.isBulkOrderCall) {
        Add up to {{ maxFiles() }} attachments in total from EIR images and uploaded files.
      } @else {
        Add up to {{ maxFiles() }} attachments in total from EIR images and uploaded files. Selected images will not be available for other
        repairs.
      }
    </p>
    @if (lineDetail) {
      <div class="pure-g aems-card">
        <div class="pure-u-md-4-24 pure-u-lg-4-24 pure-u-xl-4-24 p-r-44">
          <div class="inspection-details-value" data-test="equipmentType" title="{{ lineDetail.damageCode }}">
            {{ lineDetail.damageCode }}
          </div>
          <div class="inspection-details-label">Damage Code</div>
        </div>
        <div class="pure-u-md-4-24 pure-u-lg-4-24 pure-u-xl-4-24 p-r-44">
          <div class="inspection-details-value" data-test="equipmentType" title="{{ lineDetail.repairCode }}">
            {{ lineDetail.repairCode }}
          </div>
          <div class="inspection-details-label">Repair Code</div>
        </div>
        <div class="pure-u-md-4-24 pure-u-lg-4-24 pure-u-xl-4-24 p-r-44">
          <div class="inspection-details-value" data-test="equipmentType" title="{{ lineDetail.repairLocation }}">
            {{ lineDetail.repairLocation }}
          </div>
          <div class="inspection-details-label">Repair Loc</div>
        </div>
        <div class="pure-u-md-12-24 pure-u-lg-12-24 pure-u-xl-12-24 p-r-44">
          <div class="inspection-details-value-overflow" data-test="equipmentType" title="{{ lineDetail.repairDescription }}">
            {{ lineDetail.repairDescription }}
          </div>
          <div class="inspection-details-label">Repair Description</div>
        </div>
      </div>
    }
    @if (inspectionSummaryList && inspectionSummaryList.length > 0) {
      <p style="font-size: 12px">Images from EIR</p>
      <app-error [errors]="validationErrors()"></app-error>
    }
    <mc-c-accordion>
      @for (item of inspectionSummaryList; track $index) {
        <mc-c-accordion-item [id]="item.id.toString()" fit="medium" class="m-b-4">
          <div slot="header">
            <div class="pure-g">
              <div class="pure-u-md-6-24 pure-u-lg-6-24 pure-u-xl-6-24 p-r-100">
                <div class="inspection-details-value" data-test="equipmentType" title="{{ item.id }}">{{ item.id }}</div>
                <div class="inspection-details-label">Inspection No.</div>
              </div>
              <div class="pure-u-md-6-24 pure-u-lg-6-24 pure-u-xl-6-24 p-r-100">
                <div class="inspection-details-value" data-test="equipmentType" title="{{ item.createdOn | date }}">
                  {{ item.createdOn | date }}
                </div>
                <div class="inspection-details-label">Created On</div>
              </div>
              <div class="pure-u-md-6-24 pure-u-lg-6-24 pure-u-xl-6-24 p-r-100">
                <div class="inspection-details-value-overflow" data-test="equipmentType" title="{{ item.createdBy }}">
                  {{ item.createdBy }}
                </div>
                <div class="inspection-details-label">Created By</div>
              </div>
              <div class="pure-u-md-6-24 pure-u-lg-6-24 pure-u-xl-6-24 p-r-100">
                <div
                  class="inspection-details-value"
                  data-test="equipmentType"
                  title="{{ inspectionDetailsWithLine()?.isBulkOrderCall ? item.imageCount + 1 : item.imageCount }}">
                  <b>{{ inspectionDetailsWithLine()?.isBulkOrderCall ? item.imageCount + 1 : item.imageCount }}</b>
                </div>
                <div class="inspection-details-label">Images</div>
              </div>
            </div>
          </div>
          <app-file-select
            [readOnly]="readOnly"
            [files]="inspectionDetailsWithLine()?.isBulkOrderCall && item.report.fileUrl ? [item.report].concat(item.files) : item.files"
            [resetTrigger]="resetTrigger()"
            [lastConfirmedState]="lastConfirmedInspectionState()"
            (fileLinked)="onFileLinkedChange($event, lineDetail)">
          </app-file-select>
        </mc-c-accordion-item>
      }
    </mc-c-accordion>
    <p style="font-size: 12px">Upload New Images</p>
    <div class="pure-g">
      <div class="pure-u-md-12-24 pure-u-lg-12-24 pure-u-xl-12-24 p-r-12">
        <app-file-input
          [files]="files"
          [maxFiles]="maxFiles()"
          [existingFileCount]="attachmentCount"
          type="compact"
          (onFilesAttached)="onFileAttached($event)"></app-file-input>
      </div>
      <div class="pure-u-md-12-24 pure-u-lg-12-24 pure-u-xl-12-24">
        <!-- 2nd: Uses files as viewer source -->
        <app-file-preview [files]="files" (thumbnailClicked)="onThumbnailClicked($event, 'excludingSelected')"></app-file-preview>
      </div>
    </div>
    <mc-button
      label="Cancel"
      slot="secondaryAction"
      dialogaction="cancel"
      appearance="neutral"
      fit="small"
      (click)="closeUploadDialog()"></mc-button>
    <mc-button
      label="Done"
      [disabled]="disableDoneForUpload"
      slot="primaryAction"
      dialogaction="ok"
      appearance="primary"
      fit="small"
      (click)="onDone(lineDetail)"></mc-button>
  </mc-modal>
  @if (labelForCompact()) {
    <mc-label for="image-button" fit="small" [label]="labelForCompact()"> </mc-label>
  }
  <div class="thumbnail-container">
    @if (!readOnly) {
      <mc-button
        [disabled]="disabled()"
        label="Button "
        variant="filled"
        appearance="neutral"
        fit="small"
        icon="paperclip"
        hiddenlabel
        padding="default"
        class="file-upload-button"
        (click)="onOpenAttachmentClicked()">
      </mc-button>
    }
    <div>
      <!-- 3rd: Uses selectedAndUploadedFiles as viewer source -->
      <app-file-preview
        [files]="selectedAndUploadedFiles"
        type="compact"
        (thumbnailClicked)="onThumbnailClicked($event, 'default')"></app-file-preview>
    </div>
  </div>
}
@if (openFileViewer) {
  <!-- File viewer now uses currentViewerFiles which changes based on context -->
  <app-file-viewer
    [navDisplayText]="navDisplayTextForFileViewer"
    [readOnly]="readOnly"
    [openFileViewer]="openFileViewer"
    [file]="selectedFile"
    [disableNext]="disableNext"
    [disablePrevious]="disablePrevious"
    [workOrderMode]="workOrderMode()"
    (fileViewerClosed)="onFileViewerClosed()"
    (fileDelete)="onDeleteFile($event)"
    (nextClicked)="onNextClicked()"
    (previousClicked)="onPreviousClicked()"></app-file-viewer>
}
